const rowEditor = () => {
  return {
    className: 'row-edit',
    rowEditor,
    exportable: false,
  }
}

export default rowEditor
